import React from 'react';

const StepProgress = ({ currentIndex = 0, total = 0, labelPrefix = 'Step' }) => {
  const safeTotal = Math.max(0, Number(total) || 0);
  const safeIndex = Math.min(Math.max(Number(currentIndex) || 0, 0), Math.max(safeTotal - 1, 0));
  const percentage = safeTotal > 0 ? ((safeIndex + 1) / safeTotal) * 100 : 0;

  return (
    <div className="tutorial-progress">
      <span>{labelPrefix} {safeIndex + 1} of {safeTotal}</span>
      <div className="progress-bar">
        <div className="progress-fill" style={{ width: `${percentage}%` }}></div>
      </div>
    </div>
  );
};

export default StepProgress;


